import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiFetch } from '../../../utils';
import { useModal } from '../modal';

import ModalButton from '../modal_button';
import LoginModal from '../login';
import RulesModal from '../rules';

import { restoreUser, setUser } from '../../../store/session';

import './index.css';

const SignUpModal = () => {
    const dispatch = useDispatch();
    const { closeModal } = useModal();

    const sessionUser = useSelector(state => state?.session?.user);

    const [name, setName] = useState('');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [birthday, setBirthday] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [rules, setRules] = useState(false);
    const [errors, setErrors] = useState(false);
    const [loading, setLoading] = useState(false);

    const isSessionUser = (value) => {
        return Boolean(value && typeof value === 'object' && !Array.isArray(value) && value.id);
    };

    useEffect(() => {
        if (sessionUser !== null) {
            closeModal();
        }
    }, [sessionUser, closeModal]);

    const validate = () => {
        const newErrors = {};
        if (name && (name.length < 4 || name.length > 32)) newErrors.name = ['Account name (4-32) characters.'];
        if (username && (username.length < 4 || username.length > 32)) newErrors.username = ['Username (4-32) characters.'];
        if (email && (email.length < 5 || email.length > 64)) newErrors.email = ['Email (5-64) characters.'];
        if (birthday && (birthday.length !== 10)) newErrors.birthday = ['Birthday must be formatted: YYYY-MM-DD'];
        if (password && (password.length < 6 || password.length > 32)) newErrors.password = ['Password (6-32) characters.'];
        if (password && (password2 && password !== password2)) newErrors.password = ['Passwords must match.'];
        if (!rules) newErrors.rules = ['You must agree to the rules.'];
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({});

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        const response = await apiFetch('/auth/create_account', 'POST', {name, username, email, birthday, password, password2})
        if (!response || response.code !== 'success') {
            setLoading(false);
            setErrors(response.data);
            return;
        };

        const authUser = await dispatch(restoreUser());
        setLoading(false)

        if (authUser) {
            closeModal();
            return;
        }

        if (isSessionUser(response.data)) {
            dispatch(setUser(response.data));
            closeModal();
            return;
        }

        if (!authUser) {
            setErrors({ msg: ['Account created, but the session could not be loaded. Please refresh and try again.'] });
            return;
        }
    };

    const buttonDisabled = name.length < 1 || username.length < 1 || email.length < 1 || password.length < 1 || password2.length < 1 || loading;
    const handleButtonDown = (e) => {
        if (e.key !== 'Enter' && e.key !== 'Tab') return;
        e.preventDefault();
        
        const form = e.target.form;
        const index = [...form].indexOf(e.target);
        let nextIndex = index + 1;
        if (nextIndex === 4) nextIndex = 5;
        else if (nextIndex === 6) {
            if (buttonDisabled) return;
            return handleSubmit(e);
        };
        const nextFocus = form[nextIndex];
        nextFocus.focus();
    }

    return (
        <div id='modal-signup'>
            <div id='modal-container'>
                <div id='modal-container-signup'>
                    <div className='modal-panel-header'>
                        <h2 className='modal-panel-title'>Create Account</h2>
                        <button
                            type='button'
                            className='button modal-panel-close'
                            title='Close signup'
                            onClick={closeModal}
                        >
                            Close
                        </button>
                    </div>

                    <form className='modal-form' onSubmit={handleSubmit}>

                        {errors?.msg && errors.msg.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                        {errors?.name && errors.name.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                        {errors?.username && errors.username.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                        {errors?.email && errors.email.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                        {errors?.password && errors.password.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                        {errors?.password2 && errors.password2.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                        {errors?.rules && errors.rules.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}

                        <div id='signup-accname-container'>
                            <div className='signup-accname-ele'>
                                <label className="modal-label"> Account Name: (login)
                                    <input className="modal-input model-input-modified" type="text" value={name} required
                                        autoFocus
                                        onKeyDown={handleButtonDown}
                                        minLength={4}
                                        maxLength={32}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </label>
                            </div>

                            <div className='signup-accname-ele'>
                                <label className="modal-label"> Username: (forum)
                                    <input className="modal-input model-input-modified" type="text" value={username} required
                                        onKeyDown={handleButtonDown}
                                        minLength={4}
                                        maxLength={32}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </label>
                            </div>
                        </div>

                        <div id='signup-email-container'>
                            <div id='signup-email-left'>
                                <label className="modal-label"> Email: (login)
                                    <input className="modal-input model-input-modified-email" type="text" value={email} required
                                        onKeyDown={handleButtonDown}
                                        minLength={6}
                                        maxLength={60}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </label>
                            </div>

                            <div id='signup-email-right'>
                                <label className="modal-label"> Birthday: YYYY-MM-DD
                                    <input className="modal-input model-input-modified" type="text" value={birthday} required
                                        onKeyDown={handleButtonDown}
                                        minLength={10}
                                        maxLength={10}
                                        onChange={(e) => setBirthday(e.target.value)}
                                    />
                                </label>
                            </div>
                        </div>

                        <label className="modal-label"> Password:
                            <input className="modal-input" type={!showPassword ? "password" : "text"} value={password} required
                                onKeyDown={handleButtonDown}
                                minLength={6}
                                maxLength={32}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button className='signup-show-password'
                                title='Show Password'
                                onClick={(e) => {e.preventDefault(); setShowPassword(!showPassword)}}
                            >{showPassword ? <i className="fa-solid fa-eye"/> : <i className="fa-solid fa-eye-slash"/>}</button>
                        </label>

                        <label className="modal-label"> Confirm Password:
                            <input className="modal-input" type={!showPassword ? "password" : "text"} value={password2} required
                                onKeyDown={handleButtonDown}
                                minLength={6}
                                maxLength={32}
                                onChange={(e) => setPassword2(e.target.value)}
                            />
                        </label>

                        <div id='signup-rules-container'>
                            <ModalButton
                                id='signup-rules-button'
                                className='button'
                                type='button'
                                title='Read server rules'
                                buttonText='Read Rules'
                                modalComponent={<RulesModal />}
                            />

                            <label htmlFor='signup-rules-input' className='signup-rules-agree-label'>
                                I have read and agree to the server rules
                                <input id='signup-rules-input' type='checkbox' name='rules' checked={rules}
                                    onChange={(e) => {
                                        setRules(e.target.checked);
                                        setLoading(false);
                                    }}
                                />
                            </label>
                        </div>
                        <p id='signup-rules-helper'>Read Rules, then check the bubble to the right to continue signup.</p>

                        <div id='signup-buttons'>
                            <button className='signup-button'
                                type='submit'
                                disabled={buttonDisabled}
                                title={buttonDisabled ? 'Fill out the form' : 'Sign-Up'}
                            >Sign-Up</button>

                            <ModalButton className='signup-button signup-login-button'
                                type='button'
                                buttonText={loading ? 'Loading' : 'Login'}
                                title='Already Registered?'
                                modalComponent={<LoginModal />}
                            />
                        </div>
                        
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SignUpModal;